export default __webpack_public_path__ + "media/images/news-03-370x270-009ac7dd7b6b4d012ef132e8a87c7336.jpg";